import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { 
  Box, Typography, Card, CardContent, Avatar, Grid, 
  Divider, Button, IconButton, Chip 
} from '@mui/material';
import AuthContext from "flexbiz-core/components/auth/Context";

// Import Siêu Component
import DataListManager from 'flexbiz-core/components/DataListManager'; 

// Icons cho UI Custom
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import HistoryIcon from '@mui/icons-material/History';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EmailIcon from '@mui/icons-material/Email';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// Tiện ích lấy màu ngẫu nhiên cho Avatar dựa trên tên
const getAvatarColor = (name) => {
  if (!name) return '#9e9e9e';
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 70%, 40%)`;
};

const getInitials = (name) => {
  if (!name) return <PersonIcon />;
  const parts = name.trim().split(' ');
  return parts[parts.length - 1].charAt(0).toUpperCase();
};

export default function CustomerListPage() {
  const history = useHistory();
  const context = useContext(AuthContext);

  // ================= 1. CẤU HÌNH FIELDS =================
  const customerFields = [
    { field: "ma_kh", label: "Mã KH", type: "String", step: 1, stepLabel: "Thông tin khách hàng",isSubTitle:true, maxLength: 100,searchable: true,readOnly:true,hideInForm: (context, data) => !data._id },
    { field: "ten_kh", label: "Họ và tên", type: "String", step: 1, required: true, maxLength: 100,isTitle:true },
    { field: "dien_thoai", label: "Số điện thoại", type: "String", step: 1, required: true, maxLength: 15,gridEdit:{xs:6} },
    { field: "email", label: "Email", type: "String", maxLength: 100, step: 1,gridEdit:{xs:6} },
    { field: "ma_so_thue", label: "Mã số thuế", type: "String", maxLength: 20, step: 1,gridEdit:{xs:6} },
    { field: "cccd", label: "Số CCCD / CMND", type: "String", maxLength: 20, step: 1,gridEdit:{xs:6} },
    { field: "dia_chi", label: "Địa chỉ thường trú", type: "String", multiline: true, maxLength: 255, step: 1 },

    { field: "ho_so_dinh_kem", label: "Hồ sơ đính kèm", step: 2, stepLabel: "Tài liệu" , type: "FileArray",accept: "image/png, image/jpeg,.pdf, .doc, .docx"},
    
    // Thuộc tính hideInForm: true sẽ làm field này biến mất khỏi Modal Add/Edit
    
    { field: "trang_thai", label: "Trạng thái", type: "String", hideInForm: true,hideInList:true,hideInView:true },
    { field: "ten_trang_thai", label: "Trạng thái", type: "String", hideInForm: true },
    { field: "so_don_hang_bds", label: "Số đơn hàng", type: "String", hideInForm: true },
    { field: "date_created", label: "Ngày tạo", type: "Date", hideInForm: true }
  ];

  // ================= 2. CUSTOM RENDER ITEM (CRM CARD) =================
  const renderCustomerCard = (item, index, onEdit, onDelete, onView) => {
    const handleCall = (phone) => { if (phone) window.location.href = `tel:${phone}`; };
    const handleEmail = (email) => { if (email) window.location.href = `mailto:${email}`; };
    const handleZalo = (phone) => { if (phone) window.location.href = `https://zalo.me/${phone}`; };

    return (
      <Card 
        key={item._id || index} 
        sx={{ 
          height: '100%', 
          display: 'flex', 
          flexDirection: 'column', 
          //mb: 2, 
          borderRadius: 3, 
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)', 
          border: 'none',
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }
        }}
      >
        <CardContent sx={{ p: '16px !important', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          
          {/* ---- TẦNG 1: THÔNG TIN CHÍNH (Đẩy giãn bằng flexGrow: 1) ---- */}
          <Box sx={{ flexGrow: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
              <Avatar sx={{ bgcolor: getAvatarColor(item.ten_kh), width: 50, height: 50, mr: 1.5, fontWeight: 'bold', fontSize: '1.2rem' }}>
                {getInitials(item.ten_kh)}
              </Avatar>
              
              <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="#1c1c1e" sx={{ lineHeight: 1.2, mb: 0.5, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {item.ten_kh}
                  </Typography>
                  {item.ten_trang_thai && <Chip label={item.ten_trang_thai} size="small" sx={{ bgcolor: item.color || '#e0e0e0', color: 'white', fontWeight: 'bold', fontSize: '0.65rem', height: 20, ml: 1, flexShrink: 0 }} />}
                </Box>
                
                {/* THÔNG TIN LIÊN LẠC */}
                <Box sx={{ mt: 0.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box sx={{ overflow: 'hidden', pr: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', color: '#007aff', mb: 0.2 }}>
                      <PhoneIcon sx={{ fontSize: 14, mr: 0.5 }} />
                      <Typography variant="body2" fontWeight="500">{item.dien_thoai || '---'}</Typography>
                    </Box>
                    {item.email && (
                      <Box sx={{ display: 'flex', alignItems: 'center', color: '#5856d6' }}>
                        <EmailIcon sx={{ fontSize: 14, mr: 0.5 }} />
                        <Typography variant="caption" noWrap sx={{ maxWidth: '100%' }}>{item.email}</Typography>
                      </Box>
                    )}
                  </Box>

                  {/* CỤM NÚT LIÊN LẠC NHANH */}
                  <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
                    {item.dien_thoai && (
                      <>
                          <IconButton size="small" onClick={() => handleCall(item.dien_thoai)} sx={{ bgcolor: '#e1f5fe', color: '#0288d1', p: 0.5 }}>
                              <PhoneIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {/* ================= THAY ĐỔI: LOGO ZALO ================= */}
                          <IconButton size="small" onClick={() => handleZalo(item.dien_thoai)} sx={{ bgcolor: '#f0f4f8', p: 0.5 }}>
                            <img src='/images/zalo.png' alt="zalo" style={{ width: 18, height: 18, objectFit: 'contain' }} />
                          </IconButton>
                          {/* ======================================================== */}
                      </>
                    )}
                    {item.email && (
                      <IconButton size="small" onClick={() => handleEmail(item.email)} sx={{ bgcolor: '#f3e5f5', color: '#7b1fa2', p: 0.5 }}>
                          <EmailIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    )}
                  </Box>
                </Box>

                <Typography variant="caption" color="text.secondary" noWrap display="block" sx={{ mt: 1 }}>
                  {item.dia_chi || 'Chưa cập nhật địa chỉ'}
                </Typography>
              </Box>
            </Box>
          </Box>
          
          {/* ---- TẦNG 2: CÁC NÚT CHỨC NĂNG (Gom chung vào Box đáy với mt: 'auto') ---- */}
          <Box sx={{ mt: 'auto', pt: 1 }}>
            
            {/* CỤM CRM CHUYỂN XUỐNG ĐÂY */}
            <Box sx={{ bgcolor: '#f2f2f7', borderRadius: 2, p: 1.5, mb: 1.5 }}>
              <Grid container spacing={1} justifyContent="space-between">
                <Grid size={{ xs: 3 }} sx={{ textAlign: 'center' }}>
                  <IconButton onClick={() => history.push(`/ctv-sales-history?ma_kh=${item.ma_kh}`)} sx={{ bgcolor: 'white', color: '#ff9500', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', mb: 0.5 }}>
                    <ShoppingCartIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', fontWeight: '500' }}>Đơn hàng</Typography>
                </Grid>

                <Grid size={{ xs: 3 }} sx={{ textAlign: 'center' }}>
                  <IconButton onClick={() => history.push(`/customer-funnel?ma_kh=${item.ma_kh}`)} sx={{ bgcolor: 'white', color: '#34c759', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', mb: 0.5 }}>
                    <LocalOfferIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', fontWeight: '500' }}>Deal</Typography>
                </Grid>

                <Grid size={{ xs: 3 }} sx={{ textAlign: 'center' }}>
                  <IconButton onClick={() => history.push(`/customer-care/${item.ma_kh}`)} sx={{ bgcolor: 'white', color: '#007aff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', mb: 0.5 }}>
                    <SupportAgentIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', fontWeight: '500' }}>Chăm sóc</Typography>
                </Grid>

                <Grid size={{ xs: 3 }} sx={{ textAlign: 'center' }}>
                  <IconButton onClick={() => history.push(`/ctv-sales-history?ma_kh=${item.ma_kh}`)} sx={{ bgcolor: 'white', color: '#8e8e93', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', mb: 0.5 }}>
                    <HistoryIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="caption" display="block" sx={{ fontSize: '0.65rem', fontWeight: '500' }}>Lịch sử</Typography>
                </Grid>
              </Grid>
            </Box>

            <Divider sx={{ mb: 1.5, borderStyle: 'dashed' }} />
            
            {/* ACTION BAR ĐÁY */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                Tạo: {item.date_created ? new Date(item.date_created).toLocaleDateString('vi-VN') : '---'}
              </Typography>
              
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                <Button size="small" startIcon={<VisibilityOutlinedIcon fontSize="small" />} onClick={() => onView(item)} sx={{ textTransform: 'none', color: '#34c759', px: 1, minWidth: 0, '& .MuiButton-startIcon': { mr: { xs: 0, sm: 0.5 } } }}>
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Chi tiết</Box>
                </Button> 
                <Button size="small" startIcon={<EditIcon fontSize="small" />} onClick={() => onEdit(item)} sx={{ textTransform: 'none', color: '#ff9500', px: 1, minWidth: 0, '& .MuiButton-startIcon': { mr: { xs: 0, sm: 0.5 } } }}>
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Sửa</Box>
                </Button>
                <Button size="small" startIcon={<DeleteOutlineIcon fontSize="small" />} onClick={() => onDelete(item._id)} sx={{ textTransform: 'none', color: '#ff3b30', px: 1, minWidth: 0, '& .MuiButton-startIcon': { mr: { xs: 0, sm: 0.5 } } }}>
                  <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Xoá</Box>
                </Button>
              </Box>
            </Box>

          </Box>

        </CardContent>
      </Card>
    );
  };

  // ================= 3. RENDER =================
  return (
    <DataListManager
      title="Quản lý khách hàng"
      code="customer"
      condition={{ isbuyer:true }} 
      defaultValues={{ 
        isbuyer:true
      }}
      sortOptions={[
        { label: "Mới nhất", sort: { date_created: -1 } },
        { label: "Cũ nhất", sort: { date_created: 1 } },
        { label: "Tên A-Z", sort: { ten_kh: 1 } },
        { label: "Tên Z-A", sort: { ten_kh: -1 } }
        ]}
      fields={customerFields}
      canAdd={true}
      canEdit={true}
      canDelete={true}
      onBack={() => history.goBack()}
      renderItem={renderCustomerCard} 
      quickFilterConfig={{
        field: "trang_thai", // Cột trong bảng Đơn hàng dùng để lọc
        api: "trangthai", 
        apiCondition: { ma_ct: "CUSTOMER" }, 
        apiMapping: { value: "ma_trang_thai", label: "ten_trang_thai" }
        }}
    />
  );
}